
/* injects from baggage-loader */

'use strict';

import DocumentUploadModalController from './documentuploadmodal.controller';
import DocumentUploadModalTemplate from './documentuploadmodal.html';

export default class DocumentUploadModalComponent {
		constructor() {
				this.templateUrl = DocumentUploadModalTemplate;
				this.controller = DocumentUploadModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/components/documentUploadModal/documentuploadmodal.component.js